// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import ElementErrorRenderer from './ElementErrorRenderer';
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';

const getErrorMessage = (error) => `Error rendering element: ${error.toString()}`;

const getRollbarErrorDetails = (error, info, props) => ({
    elementId: props.elementId,
    stack: info.componentStack,
});

const ElementErrorBoundary = (props) => (
    <ErrorBoundary
        {...props}
        doNotReport={props.isPresentational}
        ErrorRenderer={ElementErrorRenderer}
        getErrorMessage={getErrorMessage}
        getRollbarErrorDetails={getRollbarErrorDetails}
    />
);

ElementErrorBoundary.propTypes = {
    elementId: PropTypes.string,
    isPresentational: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ElementErrorBoundary;
